import { makeStyles } from '@material-ui/core/styles'
import PageMetaData, { BUTTON_SIZE } from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPositionY: ({ backgroundImagePosition }) => backgroundImagePosition || 'center',
			backgroundPositionX: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ opacity }) => (opacity || 0) / 100,

				[theme.breakpoints.down('sm')]: {
					opacity: ({ mobileOpacity }) => (mobileOpacity || 0) / 100,
				},
			},
		},
		grid: {
			zIndex: 2,
			marginLeft: 'auto',
			marginRight: 'auto',
			display: 'flex',
			flexGrow: ({ isMobile }) => (isMobile ? 1 : null),
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'stretch',
			width: '100%',
		},

		text: {
			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => (mobileAlignment ? `${mobileAlignment} !important` : null),
				},
			},
		},

		mobileImageWrapper: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			transition: theme.transitions.create(['margin-top', 'margin-bottom']),
			marginTop: ({ mobileImagePosition }) =>
				mobileImagePosition === PageMetaData.ALIGNMENT.RIGHT ? theme.spacing(3) : null,
			marginBottom: ({ mobileImagePosition }) =>
				mobileImagePosition === PageMetaData.ALIGNMENT.LEFT ? theme.spacing(3) : null,
		},

		mobileImage: {
			width: '100%',

			'& picture': {
				width: '100%',
			},
			'& img': {
				width: '100%',
				objectFit: 'contain',
			},
		},

		actionContainer: {
			[theme.breakpoints.down('sm')]: {
				justifyContent: ({ mobileAlignment }) => PageMetaData.CONTENT_ALIGNMENT[mobileAlignment] || null,
			},
		},

		button: {
			minWidth: theme.spacing(44.5),

			[theme.breakpoints.down('sm')]: {
				minWidth: 'auto',
				width: ({ mobileButtonWidth }) => (mobileButtonWidth === BUTTON_SIZE.WIDE ? '100%' : 'auto'),
			},
		},
	}),
	{ name: 'Banners-Banner1' },
)

export default useStyles
